"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _FemaGoModal = _interopRequireDefault(require("./modal/FemaGoModal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var DeleteModal = function DeleteModal(props) {
  return /*#__PURE__*/_react.default.createElement(_FemaGoModal.default, {
    title: props.displayTitle ? props.displayTitle : 'Delete ' + props.title,
    type: "alert",
    open: _lodash.default.get(props, 'open', false),
    confirmAction: props.deleteAction,
    buttonText: "Delete",
    cancelAction: props.cancelAction
  }, /*#__PURE__*/_react.default.createElement("p", null, props.displayText ? props.displayText : 'Are you sure you want to delete ' + props.title + '?'));
};
DeleteModal.propTypes = {
  displayTitle: _propTypes.default.string,
  title: _propTypes.default.string,
  open: _propTypes.default.bool.isRequired,
  cancelAction: _propTypes.default.func.isRequired,
  deleteAction: _propTypes.default.func.isRequired,
  displayText: _propTypes.default.string
};
var _default = DeleteModal;
exports.default = _default;